// SHARED-008: Progress bar component

interface ProgressBarProps {
  value: number;
  max: number;
  color?: string;
  showPercent?: boolean;
  className?: string;
}

export function ProgressBar({
  value,
  max,
  color = 'var(--color-primary)',
  showPercent = false,
  className = '',
}: ProgressBarProps) {
  const percent = max > 0 ? Math.min(100, (value / max) * 100) : 0;

  return (
    <div className={`progress-bar-container ${className}`} style={{
      width: '100%',
      height: '12px',
      background: 'var(--color-bg-base)',
      borderRadius: 'var(--radius-sm)',
      border: '1px solid var(--border-color)',
      overflow: 'hidden',
      position: 'relative',
    }}>
      <div style={{
        width: `${percent}%`,
        height: '100%',
        background: color,
        transition: 'width var(--transition-normal)',
      }} />
      {showPercent && (
        <span style={{
          position: 'absolute',
          right: '4px',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-text-secondary)',
        }}>
          {Math.round(percent)}%
        </span>
      )}
    </div>
  );
}
